import { SVGProps } from 'react';

export default function Prepare8(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3362)">
        <path
          d="M1.87183 4.42991C2.1543 4.10239 2.48639 3.82119 2.856 3.59657L7.856 0.596573C8.50317 0.206889 9.24431 0.000976562 9.99975 0.000976563C10.7552 0.000976562 11.4963 0.206889 12.1435 0.596573L17.1435 3.59657C17.5135 3.82097 17.8459 4.10218 18.1285 4.42991L10.0002 9.30741L1.87183 4.42991ZM10.8335 10.7499V19.9074C11.2954 19.8162 11.7383 19.6472 12.1435 19.4074L17.1435 16.4074C17.7592 16.0355 18.2689 15.5113 18.6232 14.8853C18.9776 14.2593 19.1648 13.5526 19.1668 12.8332V7.16657C19.1639 6.72899 19.0913 6.29468 18.9518 5.87991L10.8335 10.7499ZM9.16683 10.7499L1.0485 5.87991C0.909037 6.29468 0.836463 6.72899 0.833496 7.16657V12.8332C0.835559 13.5524 1.02271 14.2589 1.37693 14.8847C1.73116 15.5105 2.24052 16.0346 2.856 16.4066L7.856 19.4066C8.26144 19.6463 8.7047 19.8154 9.16683 19.9066V10.7499Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3362">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
